const MuiCircularProgress = () => ({
  defaultProps: {
    color: "inherit",
  },
});
export default MuiCircularProgress;
